import { StoreOption } from '../components/passes/guest/type';
import { PassLocation } from '../models/IPassLocation';
import { AppConfig } from './constants';

export const sortPassLocations = (locations: PassLocation[]): StoreOption[] => {
  return (
    locations
      .sort((a, b) => a.store.localeCompare(b.store))
      .map(store => ({
        value: store.passLocationId,
        label: store.store,
        shoppingDays: store.shoppingDays,
      })) || []
  );
};

export function getCurrencyByCountryCode(countryCode: number | undefined): string {
  if (typeof countryCode !== 'number' || isNaN(countryCode)) {
    return '$';
  }
  const assoc = AppConfig.countryCurrencyAssoc.find(item => item.countryCode === countryCode);
  return assoc?.currency || '$';
}
